// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const PlanTeamViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-planteamview" */ "./PlanTeamView")).then((page)=>{
        return {
            default: page.PlanTeamView
        };
    });
export const LazyPlanTeamView = /*#__PURE__*/ lazy(PlanTeamViewLazyLoader);
